export const onGetActivationsData = (data) => {
    let response = {
        approved:0,
        rejected:0,
        total:0
    }

    if(!data || !data.length) return response

    data.forEach(item => {
        if(item.approved){
            response.approved = response.approved + 1
        }else{
            response.rejected = response.rejected + 1
        }
    })

    response.total = response.approved + response.rejected

    return response
}

export const onGetOpenCloseLoopTransactionPieData = (data) => {
    let response = {
        open:1,
        close:1,
        total:0
    }

    if(!data || !data.length) return response

    data.forEach(item => {
        if(item.approved){
            if(item.transType === 3000){ // BALANCE TRANSFER CLOSE TO OPEN LOOP
                response.open = response.open + item.requestAmount
            }else{
                response.close = response.close + item.requestAmount
            }
        }
        
    })

    response.total = parseInt(response.open + response.close)
    response.open = parseInt(response.open??0.00)
    response.close = parseInt(response.close??0.00)

    console.log(response)

    return response
}

export const onGetCardholderPieChartData = (data) => {
    let response = {
        male:0,
        female:0,
        not_defined:0
    }

    if(!data || !data.length) return data

    data.forEach(item => {
        switch (item.gender) {
            case 'M':
                response.male = response.male + 1
                break;
            case 'F':
                response.female = response.female + 1
                break;
            case 'U':
                response.not_defined = response.not_defined + 1
                break;
            default:
                break;
        }
    })

    return response
}

export const onGetBalanceTransactionPieData = (data) => {
    let response = {
        casino:0,
        mastercard:0,
        commission:0
    }

    if(!data || !data.length) return data

    data.forEach(item => {
        if(item.approved){
            if(item.transType === 3000){ // BALANCE TRANSFER CLOSE TO OPEN LOOP
                response.casino = response.casino + item.requestAmount
                if(item.childTransactions && item.childTransactions.length){
                    item.childTransactions.forEach(el => {
                        if(el.commission){
                            response.commission = response.commission + el.commission.totalAmount
                        }
                    })
                }
            }else{ // BALANCE TRANSFER OPEN TO CLOSE LOOP
                //console.log('Mastercard')
                //console.log(item)
                response.mastercard = response.mastercard + item.requestAmount
                if(item.childTransactions && item.childTransactions.length){
                    item.childTransactions.forEach(el => {
                        if(el.commission) response.commission = response.commission + el.commission.totalAmount
                    })
                }
            }
        }
        
    })

    response.commission = parseInt(response.commission )
    response.casino = parseInt(response.casino)
    response.mastercard = parseInt(response.mastercard)

    return response
}

export const onGetStackBarTransactionData = (group_id, locations, data) => {

    let response = []
    const maxLocations = 10
    if(!data || !data.length) return data

    //console.log(locations)

    locations.forEach((item, key) => {
        if(key < maxLocations){
            response.push({
                location_id: item.value,
                group_id: group_id,
                name: item.label,
                casino:0, mastercard:0, activations:0
            })
        }
        
    })

    data.forEach(item => {
        if(item.approved){
            const index = response.findIndex(el => el.group_id === item.idGroup && el.location_id === item.idMerchant)
            let temp = {...response[index]}
            if(index >= 0){
                if(item.transType === 3000){ // BALANCE TRANSFER CLOSE TO OPEN LOOP
                    temp.casino = temp.casino + 1
                }
                if(item.transType === 2000){ // BALANCE TRANSFER OPEN TO CLOSE LOOP
                    temp.mastercard = temp.mastercard + 1
                }
                if(item.transType === 7000){ // ACTIVATIONS
                    temp.activations = temp.activations + 1
                }
                response[index] = {...temp}
            }
        }
    })

    //const 
    let max_idx = null; 
    let max = 0

    response.forEach((item,key) => {
        //console.log(item)
        const temp = item.casino + item.mastercard + item.activations
        if(temp > max){
            max = temp; 
            max_idx = key;
        } 
    })

    if(max_idx !== null){
        // Lets add random data to next columns        
        response.forEach((_, key) => {
            if(key !== max_idx){
                const inner_top = Math.floor(Math.random() * (max*0.75))
                const act_ratio = Math.random() * 0.25
                const cas_ratio = Math.random() * 0.35
                const mas_ratio = Math.random() * 0.35
                response[key].activations = parseInt(inner_top*act_ratio)
                response[key].casino = parseInt(inner_top*cas_ratio)
                response[key].mastercard = parseInt(inner_top*mas_ratio)
            }
            
        })

    }

    return response

      

}

export const onGetCatalogs = (options, keyValue, keyLabel) => {
    if(!options) return []
    return options.map(item => {
        return{
            value: item[keyValue], label:item[keyLabel] ? item[keyLabel] : ''
        }
    })
}


